import { IntlMessageID } from "~/providers/I18nProvider";

export const ForgotPasswordError: Record<
  string,
  { message: IntlMessageID; description?: IntlMessageID }
> = {
  //Keys come from backend
  UserSSOEnabled: {
    message: "ForgotPassword.Error.SSOEnabled.Message",
  },
  TooManyAttemptToResetPassword: {
    message: "ForgotPassword.Error.TooManyAttemptToResetPassword.Message",
  },
  ExceedLimitSuccessfulResetPassword: {
    message: "ForgotPassword.Error.ExceedLimitSuccessfulResetPassword.Message",
  },
};
